import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Box, Dialog, InputBase, DialogContent, DialogActions, Typography, ListItem, Grid, IconButton, CircularProgress } from '@material-ui/core';
import { Close, Search } from '@material-ui/icons'
import { useDataProvider, useTranslate } from 'react-admin';
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import { makeStyles } from '@material-ui/core/styles'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import CustomPoperCalendar from '../CustomizedUIs/CustomPoperCalendar'
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton'
import GreenSwitch from '../CustomizedUIs/GreenSwitch'
import moment from 'moment-timezone';
import colors from '../CustomizedUIs/Colors'
import StartCalendar from '../common/DatePicker/startCalendar'
import StopCalenrar from '../common/DatePicker/stopCalendar'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { red, pink } from '@material-ui/core/colors';
import CustomTextFiled from '../CustomizedUIs/CustomTextFiled'
import DeleteIcon from '../assets/icons/primary-blue-bin.png'
import icSearch from '../assets/icons/grayscale-3-search.png'
import CloseButton from '../CustomizedUIs/CloseButton';

const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({
  input: {
    backgroundColor: 'white',
    borderRadius: '2px',
    "&:hover": {
      backgroundColor: 'white'
    }, fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.85,
    letterSpacing: '0.13px',
    color: '#88898c',
  },
  boxBoder: {
    borderBottom: '1px solid',
    borderRight: '1px solid',
    borderBottomColor: theme.palette.grey['200'],
    borderRightColor: theme.palette.grey['200'],
  },
  underline: {
    '&::before': {
      borderBottom: '1px solid black'
    },
    '&:hover:before': {
      borderBottom: '1px solid black'
    }
  },
  underlineCodeInput: {
    "&&&:before": {
      borderBottom: "none",
      content: '""'
    },
    "&&:after": {
      borderBottom: "none"
    }
  },
  password: {
    fontFamily: 'text-security-disc',
    "-webkit-text-security": "disc",
  },
  underlineNotValue: {
    '&::before': {
      borderBottom: '1px solid' + colors.lightBlue['200']
    },
    '&:hover:before': {
      borderBottom: '1px solid' + colors.lightBlue['200']
    }
  },
  focuses: {
    backgroundColor: 'white !important'
  },
  popover: {
    position: 'relative',
    marginLeft: '1em'
  },
  dialogPaper: {

    minHeight: '90vh',
    maxHeight: '90vh',
    backgroundColor: theme.palette.background.default
  },
  titleRoom: {
    fontFamily: 'UniviaPro-Medium',
    fontSize: '18px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: " #4f5064",
  },
  titleCluster: {
    fontFamily: 'UniviaPro-Medium',
    fontSize: '11px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: " #4f5064",
  },
  textError: {
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.85,
    letterSpacing: '0.13px',
    color: '#eb5a4d !important',
  },
  textLabel: {
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.85,
    letterSpacing: '0.13px',
    color: ' #88898c',
  },
  textLableError: {
    marginBottom: 8,
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.13px',
    color: '#eb5a4d !important',
  },
  titleDateRoom: {
    fontFamily: 'UniviaPro-Medium',
    fontSize: '11px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: '#4f5064',
    paddingBottom: 8
  },
  TitleSwitch: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: '9px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: '0.36px',
    color: '#4f5064',
  },
  btnMetaData: {
    borderRadius: '10px',
    backgroundColor: '#c1e5fa',
  },
  textMetaData: {
    fontFamily: 'UniviaPro',
    fontSize: '9px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.22,
    letterSpacing: '0.36px',
    color: '#237fc2',
    padding: 8
  },
  textClose: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: '10px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.4px',
    color: '#4f5064',
  },
  btnClose: {
    width: '28px',
    height: '28px',
    border: 'solid 2px #e5f1f8',
    backgroundColor: '#ffffff',
    padding: 0
  },
  btnCancel: {
    fontFamily: 'UniviaPro',
    fontSize: '10px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.25,
    letterSpacing: '0.4px',
    color: '#237fc2',
  },
  btnCreate: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: '11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.44px',
    color: '#ffffff',
    padding: '5px'
  },
  TextSearch: {
    fontFamily: 'UniviaPro',
    fontSize: '11px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#88898c',
    '&::placeholder': {
      color: '#88898c',
      opacity: 1
    }
  },
}));



const MetaData = ({ name, value, textOnChange, validate, onRemove }) => {
  const classes = useStyles()

  return (
    <Box display='flex' width={500} mt={1}>
      <Box display='flex' borderRadius={4} bgcolor='background.paper' alignItems='center' px={1}>
        <TextField
          required
          label="name"
          error={validate.name.isError && validate.name.message != ""}
          helperText={validate.name.isError ? validate.name.message : ""}
          value={name}
          onBlur={textOnChange('name')}
          onChange={textOnChange('name')}
          size="small"
          style={{ width: '157px' }}
          FormHelperTextProps={{
            className: classes.textError
          }}
          InputLabelProps={{
            // className: classes.textLabel,
            classes: {
              root: classes.textLabel,
              error: classes.textLableError
            }
          }}
          InputProps={{
            classes: {
              underline: classes.underlineCodeInput,
            }
          }}
        />
      </Box>
      <Box display='flex' borderRadius={4} bgcolor='background.paper' ml={2} alignItems='center' px={1}>
        <TextField
          required
          label="value"
          error={validate.value.isError && validate.value.message != ""}
          helperText={validate.value.isError ? validate.value.message : ""}
          value={value}
          onBlur={textOnChange('value')}
          onChange={textOnChange('value')}
          size="small"
          style={{ width: '157px' }}
          FormHelperTextProps={{
            className: classes.textError
          }}
          InputLabelProps={{
            // className: classes.textLabel,
            classes: {
              root: classes.textLabel,
              error: classes.textLableError
            }
          }}
          InputProps={{
            classes: {
              underline: classes.underlineCodeInput,
            }
          }}
        />
      </Box>
      <IconRadiusButton style={{ marginLeft: 8 }} onClick={onRemove}>
        <img src={DeleteIcon} width='18px' height='18px'></img>
      </IconRadiusButton>
    </Box>
  )
}



const FilterInput = ({ onChangeValue, value, name }) => {
  const classes = useStyles()
  const theme = useSelector((state) =>
    state.theme === 'dark' ? darkTheme : lightTheme
  );

  return (
    <Box display='flex' style={{ borderRadius: '8.1px', border: 'solid 0.8px #f1f2f4', backgroundColor: '#f7f7f7' }}>
      < img src={icSearch} className={classes.iconSearch} width={15} height={15} style={{ margin: 'auto 2px auto 5px' }}></img>
      <InputBase
        value={value}
        onChange={onChangeValue}
        placeholder={"Filter " + name}
        inputProps={{
          'aria-label': 'search',
          className: classes.TextSearch
        }}
        style={{ width: '180px' }}
      />
    </Box>
  )
}

const CreateRoomDialog = ({ open, handleClose, dataRecever, clusterData, ...props }) => {
  const dataProvider = useDataProvider();
  const translate = useTranslate();

  const [data, setData] = useState(dataRecever);


  const [isAddMoreRoom, setIsAddMoreRoom] = useState(false);
  const [language, setLanguage] = useState();

  const [arrayLanguage, setArrayLanguage] = useState([])
  const [switchValue, setSwitchValue] = useState({
    isParental: false,
    payTV: true,
    vod: true,
    bokaMera: false,
  })
  const [textValue, setTextValue] = React.useState({
    roomLocation: '',
    number: '',
    roomName: '',
    special: '',
    controlCode: '',
  });

  const [validate, setValidate] = React.useState({
    roomLocation: {
      isError: true,
      message: ''
    },
    number: {
      isError: true,
      message: ''
    },
    controlCode: {
      isError: false,
      message: ''
    },
    roomName: {
      isError: true,
      message: ''
    },
  });



  const [openLanguage, setOpenLanguage] = useState(false);
  const [valueStartTime, setValueStartTime] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [dateStart, setDateStart] = useState(new Date());
  const [valueStopTime, setValueStopTime] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [dateStop, setDateStop] = useState(new Date());
  const [oldDateStop, setOldDateStop] = useState(new Date());
  const [anchorElStopCalendar, setAnchorElStopCalendar] = React.useState(null);
  const [filterLanguage, setFilterLanguage] = useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElStartCalendar, setAnchorElStartCalendar] = React.useState(null);
  const [openPoper, setOpenPopper] = React.useState(false);
  const [showPassword, setShowPassword] = useState(false)
  const [noEndDate, setNoEndDate] = useState(false)
  const [loading, setLoading] = useState(false);
  const [error, setError] = React.useState("");
  const [metaDatas, setMetaDatas] = useState([])
  const [validateMetaDatas, setValidateMetaDatas] = useState([])
  const [defaultSystemLanguage, setDefaultSystemLanguage] = useState('');





  const classes = useStyles()

  // you can past mostly all available props, like minDate, maxDate, autoOk and so on

  const handleClickOpenPoper = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenPopper(true);
  };

  const handleClosePoper = () => {
    setOpenPopper(false);
  };

  const validateFc = (prop, value) => {
    if (prop == 'number') {
      if (value.length == 0)
        setValidate({
          ...validate, [prop]: value.length == 0 ? {
            isError: true, message: 'required'
          } : {
            isError: false, message: ''
          }
        })
      else {
        var error = false
        var array = value.split(",")
        for (let i = 0; i < array.length; i++) {
          if (array[i].split("-").length > 2) {
            error = true
            break
          }
        }
        const globalRegex = RegExp('([0-9]|-[0-9]|,[0-9]){1,}', 'g');
        globalRegex.test(value)
        setValidate({
          ...validate, [prop]: globalRegex.lastIndex < value.length || error || isNaN(value[0]) ? {
            isError: true, message: 'Incorrect format'
          } : {
            isError: false, message: ''
          }
        })
      }
    }
    else if (prop == 'controlCode') {
      setValidate({
        ...validate, [prop]: value.length == 0 ? {
          isError: true, message: 'required'
        } : (isNaN(value) ? {
          isError: true, message: 'allow only numberic'
        } : {
          isError: false, message: ''
        })
      })
    }
    else
      setValidate({
        ...validate, [prop]: value.length == 0 ? {
          isError: true, message: 'required'
        } : {
          isError: false, message: ''
        }
      })

  }

  //event onChang Name TextField
  const textOnChange = prop => (e) => {
    setTextValue({
      ...textValue, [prop]: e.target.value
    })
    validateFc(prop, e.target.value)
  }
  //----

  const onChangMetaData = index => prop => (e) => {
    var tempArray = metaDatas.slice()
    tempArray[index][prop] = e.target.value
    setMetaDatas(tempArray)
    validateMetaData(index)(e.target.value)(prop)

  }

  const validateMetaData = index => value => prop => {
    var validates = validateMetaDatas.slice()
    if (value == "") {
      validates[index][prop].isError = true
      validates[index][prop].message = "required"
    }
    else {
      validates[index][prop].isError = false
      validates[index][prop].message = ""
    }
    setValidateMetaDatas(validates)
  }

  const onClickMetaData = () => {
    var tempArray = metaDatas.slice()
    var validates = validateMetaDatas.slice()
    tempArray.push({
      name: "",
      value: "",
    })
    validates.push({
      name: { isError: true, message: "" },
      value: { isError: true, message: "" }
    })
    setValidateMetaDatas(validates)
    setMetaDatas(tempArray)
  }

  const onRemoveMetaData = index => () => {
    var tempArray = metaDatas.slice()
    tempArray.splice(index, 1)
    var validates = validateMetaDatas.slice()
    validates.splice(index, 1)
    setValidateMetaDatas(validates)
    setMetaDatas(tempArray)
  }


  //event select of Start Calendar

  const handleClickStartCalendar = (event) => {
    if (anchorElStartCalendar == null)
      setAnchorElStartCalendar(event.currentTarget)
    else {
      handleCloseStartCalendar()
      setAnchorElStartCalendar(null)
    }

  };

  const handleCloseStartCalendar = () => {
    setDateStart(new Date(valueStartTime))
    setAnchorElStartCalendar(null);
  };

  // const finishPickDate = () => {
  //   setValueStartTime(moment(dateStart).format('YYYY-MM-DD'))
  //   if (dateStart.getTime() > dateStop.getTime() && valueStopTime != translate(`resources.room.onGoing`)) {
  //     setDateStop(dateStart)
  //     setValueStopTime((moment(dateStart).format('YYYY-MM-DD')))
  //   }

  //   setAnchorElStartCalendar(null);
  // };

  const onChangeStartCalendar = (date) => {
    setDateStart(date)
    setValueStartTime(moment(date).format('YYYY-MM-DD'))
    if (date.getTime() > dateStop.getTime() && valueStopTime != translate(`resources.room.onGoing`)) {
      setDateStop(date)
      setValueStopTime((moment(date).format('YYYY-MM-DD')))
    }

    setAnchorElStartCalendar(null);
  }
  //----------------------




  //event select of Stop Calendar

  const handleClickStopCalendar = (event) => {
    if (anchorElStopCalendar == null)
      setAnchorElStopCalendar(event.currentTarget)
    else {
      handleCloseStopCalendar()
      setAnchorElStopCalendar(null)
    }

  };

  const handleCloseStopCalendar = () => {
    setDateStop(oldDateStop)
    setAnchorElStopCalendar(null);
    setNoEndDate(valueStopTime == translate(`resources.room.onGoing`))
  };


  const onChangNoEndDate = (e) => {
    setNoEndDate(e.target.checked)
    setValueStopTime(e.target.checked ? translate(`resources.room.onGoing`) : moment(dateStop).format('YYYY-MM-DD'))
    setAnchorElStopCalendar(null);
  }

  // const finishPickDateStop = () => {
  //   setValueStopTime(noEndDate ? translate(`resources.room.onGoing`) : moment(dateStop).format('YYYY-MM-DD'))
  //   setOldDateStop(dateStop)
  //   setAnchorElStopCalendar(null);
  // };

  const onChangeStopCalendar = (date) => {
    setDateStop(date)
    setValueStopTime(noEndDate ? translate(`resources.room.onGoing`) : moment(date).format('YYYY-MM-DD'))
    setOldDateStop(date)
    setAnchorElStopCalendar(null);

  }
  //----------------------





  //event select off Entity
  const onChangeLanguage = (value) => {
    setLanguage(value)
    setOpenLanguage(false)
  }

  const handleClickOpenLanguage = () => {
    setOpenLanguage(!openLanguage)
  }
  const onChangeFilterLanguage = (e) => {
    setFilterLanguage(e.target.value)
  }
  //----------------------

  const handleStringRoomNumber = (str) => {
    var array = str.split(",")
    var tempArray = []
    for (let i = 0; i < array.length; i++) {
      var temps = array[i].split("-")

      if (temps.length == 2) {

        if (parseInt(temps[0]) > parseInt(temps[1])) {
          let temp = temps[0]
          temps[0] = temps[1]
          temps[1] = temp
        }
        var curentId = parseInt(temps[0])

        while (curentId <= parseInt(temps[1])) {
          tempArray.push(curentId)
          curentId++
        }
      }
      else
        tempArray.push(parseInt(array[i]))
    }
    let set = new Set(tempArray)
    return Array.from(set)

  }

  const onChangSwitch = prop => (e) => {
    setSwitchValue({
      ...switchValue, [prop]: e.target.checked
    })
    if (prop == 'isParental') {
      setTextValue({
        ...textValue, controlCode: ""
      })
      setValidate({
        ...validate, controlCode: {
          isError: e.target.checked,
          message: ''
        }
      })
    }
  }


  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  };

  //Onclick  Add Rooms
  const handelAddRoom = () => {
    setLoading(true)
    dataProvider('CREATE', 'room', {
      data: {
        cluster: clusterData.id,
        name: textValue.roomName,
        nickName: textValue.roomName,
        language: language.id,
        numbers: handleStringRoomNumber(textValue.number),
        location: textValue.roomLocation,
        startDate: new Date(valueStartTime).getTime(),
        stopDate: noEndDate ? new Date().getTime() + 315569520000 : new Date(valueStopTime).getTime(),
        noEndDate: noEndDate,
        specialLocation: textValue.special,
        parentalControl: switchValue.isParental,
        payTV: switchValue.payTV,
        isVOD: switchValue.vod,
        controlCode: switchValue.isParental ? textValue.controlCode : "",
        metaData: metaDatas,
        isBokamera: switchValue.bokaMera
      }
    })
      .then((response) => {
        if (response.success) {
          if (switchValue.bokaMera) {
            dataProvider('CREATE', 'bokamera/service', {
              data: {
                roomName: textValue.roomName.trimEnd(),
                parentPath: `${clusterData?.entityGroup} - ${clusterData?.name} - ${textValue.roomLocation}`,
                roomID: response.data[0]?.data.id,
              }
            }).then(res => {
              if (res.status === 200) {
                handleClose()
              } else {
                console.log('Create bokamera service error: ', res.detail);
                setError('Create bokamera service error: ', res.detail);
                setLoading(false)
              }
            }).catch(err => {
              console.log('Create bokamera service error: ', err.detail);
              setError('Create bokamera service error: ', err.detail);
              setLoading(false)
            })
          }
           handleClose()
        }
        else {
          setError(`The roomIds already exist`)
        }
        setLoading(false)
      })
      .catch(error => {
        setError(translate(`pos.dashboard.createFailed`))
        setLoading(false)

      })

  }
  //-------------------
  const getLanguage = (defaultLanguage) => {
    let language = defaultLanguage ? defaultLanguage[0].value : null
    let code
    switch (language) {
      case 'English':
        code = 'US'
        break;
      case 'Swedish':
        code = 'SE'
        break;
      default:
        code = 'SE'
        break;
    }
    dataProvider('GET_LIST', "language", {
      filter: {

      },
      pagination: {},
      sort: { field: 'name', order: 'ASC' },

    })
      .then(({ data }) => {
        setArrayLanguage(data);
        console.log(data)
        setLanguage(data.find(value => value.code === code))
        setLoading(false);
      })
      .catch(error => {
        setError(error);
        setLoading(false);
      })
  }

  React.useEffect(() => {
    var request = []
    var defaultLanguage

    request.push(dataProvider('GET_LIST', "settings", {
      filter: {
        cluster: null,
        room: null,
        name: 'Default System Language'
      },
      sort: {},
      pagination: {}
    }).then(({ data }) => {
      setDefaultSystemLanguage(data)
      defaultLanguage = data
    })
    )
    Promise.all(request)
      .then(() => {
        setLoading(false)
        getLanguage(defaultLanguage)
      })
      .catch(() => {
        getLanguage()
        console.log('Error')
      })
    setValidate({
      roomLocation: {
        isError: true,
        message: ''
      },
      number: {
        isError: true,
        message: ''
      },
      controlCode: {
        isError: false,
        message: ''
      },
      roomName: {
        isError: true,
        message: ''
      },
    })
    setError('')
    setSwitchValue({
      isParental: false,
      payTV: true,
      vod: true,
      bokaMera: false,
    })
    setTextValue({
      roomLocation: '',
      number: '',
      roomName: '',
      special: '',
      controlCode: '',
    })
    setMetaDatas([])
    setValidateMetaDatas([])
    setNoEndDate(true)
    setValueStartTime(moment(new Date()).format('YYYY-MM-DD'))
    setValueStopTime(translate(`resources.room.onGoing`))
    setOldDateStop(new Date())
    setDateStart(new Date())
    setDateStop(new Date())
    // dataProvider('GET_LIST', "language", {
    //   filter: {
    //   },
    //   pagination: {},
    //   sort: { field: 'name', order: 'ASC' },

    // })
    //   .then(({ data }) => {
    //     setArrayLanguage(data);
    //     setLanguage(data.find(value => value.code == 'SE'))
    //   })
  }, [handleClose]);

  // console.log(arrayLanguage, language)
  if (!arrayLanguage || !language) return null


  return (

    <Box>

      <Dialog open={open} scroll='paper' classes={{ paper: classes.dialogPaper }}>

        <Box display='flex' justifyContent='flex-end' alignContent='center' mr={2} mt={2}>
          <Typography style={{ margin: 'auto 8px auto 0' }} className={classes.textClose}>  {translate(`pos.dashboard.close`)}</Typography>
 
          <CloseButton onClick={handleClose} />
        </Box>
        <Box mb={2} ml={3}>
          <Typography className={classes.titleRoom} style={{ paddingBottom: 8 }}> {translate(`resources.room.addRoom`)}</Typography>
          <Typography style={{ paddingTop: 7 }} className={classes.titleCluster}> {clusterData.group + "/" + clusterData.name}</Typography>
        </Box>
        <DialogContent dividers={false}>
          {
            error != "" && (
              <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{error}</Typography>
              </Box>
            )
          }
          <Box>
            <CustomTextFiled
              onBlur={() => {
                validateFc('roomLocation', textValue.roomLocation)
              }}
              required
              id="filled-basic"
              label={translate(`resources.room.roomLocation`)}
              error={validate.roomLocation.message != "" && validate.roomLocation.isError}
              helperText={validate.roomLocation.message}
              value={textValue.roomLocation}
              onChange={textOnChange('roomLocation')}
              style={{ width: 500 }}
              endDom={<CustomPoper
                open={openPoper}
                anchorEl={anchorEl}
                handleClick={handleClickOpenPoper}
                handleClose={handleClosePoper}
                title={translate(`resources.room.titlelocation`)}
                content={translate(`resources.room.contentlocation`)}
                icon={<b>?</b>}
              />}

            />
            <Box my={1}>

              <CustomTextFiled
                onBlur={() => {
                  validateFc('number', textValue.number)
                }}
                style={{ width: '500px' }}
                required
                id="filled-basic"
                label={translate(`resources.room.roomNumber`)}
                error={validate.number.message != "" && validate.number.isError}
                helperText={validate.number.message}
                value={textValue.number}
                onChange={textOnChange('number')}
                endDom={
                  <CustomPoper
                    open={openPoper}
                    anchorEl={anchorEl}
                    handleClick={handleClickOpenPoper}
                    handleClose={handleClosePoper}
                    title={translate(`resources.room.roomNumberTitle`)}
                    content={translate(`resources.room.roomNumberContent`)}
                    icon={<b>?</b>}
                  />
                } />
            </Box>
            {/* <Box display='flex'
                justifyItems='center'
                py={2} my={1}
                width='500px'
                bgcolor={colors.white['50']}
                border={1}
                borderColor={colors.lightBlue['200']}
                borderRadius='4px' >
                <Box mx='auto'>
                  <Typography variant='body2'>Room number</Typography>
                  <TextField
                    onBlur={() => {
                      validateFc('number', textValue.number)
                    }}
                    style={{ width: '469px' }}
                    id="filled-basic"
                    label='Number'
                    error={validate.number.message != "" && validate.number.isError}
                    helperText={validate.number.message}
                    value={textValue.number}
                    onChange={textOnChange('number')}
                    InputProps={{

                      className: classes.input,
                      classes: {
                        underline: textValue.number !== '' ? classes.underline : classes.underlineNotValue,
                        focused: classes.focuses
                      }
                    }}
                    variant="filled" />
                  <Box width='159px' bgcolor='background.paper' display='flex' alignItems='center' px={1} mt={1}>
                    <Box flexGrow={1}>
                      <Typography variant='subtitle2'>ADD MORE ROOMS</Typography>
                    </Box>
                    <GreenSwitch size='small' style={{ color: 'white' }}></GreenSwitch>
                  </Box>
                </Box>
              </Box> */}
            <Box display='flex'
              justifyItems='center'
              py={2} my={1}
              width='500px'
              bgcolor={colors.white['50']}
              border={1}
              borderColor={colors.lightBlue['200']}
              borderRadius='4px' >
              <Box mx='auto' width='469px' >
                <Typography className={classes.titleDateRoom}>{translate(`resources.room.dateStartStop`)}</Typography>
                <Grid container justify="space-between" alignItems="flex-end">
                  <Grid item style={{ width: '207px' }}>
                    <StartCalendar
                      Title={translate(`resources.room.start`)}
                      minDate={new Date()}
                      anchorEl={anchorElStartCalendar}
                      handleClick={handleClickStartCalendar}
                      handleClose={handleClickStartCalendar}
                      handleDateChange={onChangeStartCalendar}
                      // finishPickDate={finishPickDate}
                      value={valueStartTime}
                      date={dateStart}
                    />
                  </Grid>
                  <Grid item style={{ width: '207px' }}>
                    <StopCalenrar
                      Title={translate(`resources.room.stop`)}
                      isNoEndDate={noEndDate}
                      onChangNoEndDate={onChangNoEndDate}
                      minDate={valueStartTime}
                      anchorEl={anchorElStopCalendar}
                      handleClick={handleClickStopCalendar}
                      handleClose={handleClickStopCalendar}
                      handleDateChange={onChangeStopCalendar}
                      // finishPickDate={finishPickDateStop}
                      value={valueStopTime}
                      date={dateStop}
                      hideNoEndDate
                    />
                  </Grid>
                  <Grid item>
                    <CustomPoperCalendar
                      isNotInfoPage={true}
                      open={openPoper}
                      anchorEl={anchorEl}
                      handleClick={handleClickOpenPoper}
                      handleClose={handleClosePoper}
                      title={translate(`pos.messages.calendar`)}
                      content={translate(`pos.messages.constentCalendar`)}
                      icon={<b>?</b>}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>

            <Box my={1}>

              <CustomTextFiled
                id="filled-basic"
                required
                label={translate(`resources.room.roomName`)}
                error={validate.roomName.message != "" && validate.roomName.isError}
                helperText={validate.roomName.message}
                value={textValue.roomName}
                onBlur={textOnChange('roomName')}
                onChange={textOnChange('roomName')}
                style={{ width: 500 }}
                endDom={
                  <CustomPoper
                    open={openPoper}
                    anchorEl={anchorEl}
                    handleClick={handleClickOpenPoper}
                    handleClose={handleClosePoper}
                    title={translate(`resources.room.roomName`)}
                    content={translate(`resources.room.roomNameContent`)}
                    icon={<b>?</b>}
                  />
                } />
            </Box>
            <Box my={1}>
              <CustomTextFiled
                id="filled-basic"
                label={translate(`resources.room.specialLocation`)}
                value={textValue.special}
                onChange={textOnChange('special')}
                style={{ width: 500 }}
                endDom={
                  <CustomPoper
                    open={openPoper}
                    anchorEl={anchorEl}
                    handleClick={handleClickOpenPoper}
                    handleClose={handleClosePoper}
                    title={translate(`resources.room.specialLocation`)}
                    content={translate(`pos.infochannel.specialLocation`)}
                    icon={<b>?</b>}
                  />
                } />
            </Box>
            <Box pt={1} pb={0} mt={1} width='500px'>
              <SelectBox
                required={true}
                label={translate(`resources.room.language`)}
                value={
                  <Box display='flex' alignItems='center' style={{ marginTop: '-5px' }} >
                    <img src={"https://flagcdn.com/" + language.code.toLowerCase() + ".svg"} width={30} style={{ borderRadius: '2px' }} />
                    <Box className={classes.textLabel} ml={2}>{language.name}</Box>
                  </Box>

                }
                open={openLanguage}
                handleClick={handleClickOpenLanguage}>
                <Box className={classes.boxBoder}>
                  <ListItem style={{ padding: '8px' }}>
                    <FilterInput className={classes.textLabel} value={filterLanguage} onChangeValue={onChangeFilterLanguage} filterEntity name={'language'.toLowerCase()} />
                  </ListItem>
                  {
                    arrayLanguage.filter(value => value.name.toUpperCase().search(filterLanguage.toUpperCase()) > -1).map(row => (
                      <ListItem key={row.id} button onClick={() => onChangeLanguage(row)}>
                        <Box display='flex' alignItems='center' >
                          <img src={"https://flagcdn.com/" + row.code.toLowerCase() + ".svg"} width={30} />
                          <Box className={classes.textLabel} ml={2}>{row.name}</Box>
                        </Box>
                      </ListItem>

                    ))
                  }
                </Box>
              </SelectBox>
            </Box>
            <Box my={1} width='173px' mt={2} >
              <Box display='flex' borderRadius={4} bgcolor='background.paper' my={1} px={1} alignItems='center'>
                <Box flexGrow={1}>
                  <Typography className={classes.TitleSwitch}>{translate(`resources.room.parentalControl`).toUpperCase()}</Typography>
                </Box>
                <GreenSwitch checked={switchValue.isParental} onChange={onChangSwitch('isParental')}
                  size='small'></GreenSwitch>
              </Box>
              {
                switchValue.isParental && (
                  <Box display='flex' borderRadius={4} bgcolor='background.paper' mb={1} alignItems='center' px={1}>
                    <TextField
                      required
                      label={translate(`resources.room.controlCode`)}
                      onBlur={() => {
                        switchValue.isParental && validateFc('controlCode', textValue.controlCode)
                      }}
                      type={'text'}
                      value={textValue.controlCode}
                      error={validate.controlCode.message != "" && validate.controlCode.isError}
                      helperText={validate.controlCode.message}
                      onChange={textOnChange('controlCode')}
                      size="small"
                      style={{ width: '100%' }}
                      FormHelperTextProps={{
                        className: classes.textError
                      }}
                      InputLabelProps={{
                        // className: classes.textLabel,
                        classes: {
                          root: classes.textLabel,
                          error: classes.textLableError
                        }
                      }}
                      InputProps={{
                        endAdornment:
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            edge="end"
                            size='small'
                          >
                            {showPassword ? <Visibility fontSize='small' /> : <VisibilityOff fontSize='small' />}
                          </IconButton>,

                        classes: {
                          underline: classes.underlineCodeInput,
                        },
                        className: showPassword ? '' : classes.password
                      }}
                    />
                  </Box>
                )
              }


              <Box display='flex' borderRadius={4} bgcolor='background.paper' my={1} px={1} alignItems='center'>
                <Box flexGrow={1}>
                  <Typography className={classes.TitleSwitch}>{translate(`resources.room.payTV`).toUpperCase()}</Typography>
                </Box>
                <GreenSwitch checked={switchValue.payTV} onChange={onChangSwitch('payTV')} size='small'></GreenSwitch>
              </Box>
              <Box display='flex' borderRadius={4} bgcolor='background.paper' my={1} px={1} alignItems='center'>
                <Box flexGrow={1}>
                  <Typography className={classes.TitleSwitch}>{translate(`resources.room.vod`).toUpperCase()}</Typography>
                </Box>
                <GreenSwitch checked={switchValue.vod} onChange={onChangSwitch('vod')} size='small'></GreenSwitch>
              </Box>
              <Box>
                {
                  metaDatas.map((row, index) => (
                    <MetaData
                      key={index}
                      name={row.name}
                      value={row.value}
                      validate={validateMetaDatas[index]}
                      textOnChange={onChangMetaData(index)}

                      onRemove={onRemoveMetaData(index)} />
                  ))
                }
              </Box>
              <Box display='flex' borderRadius={4} bgcolor='background.paper' my={1} px={1} alignItems='center'>
                <Box flexGrow={1}>
                  <Typography className={classes.TitleSwitch}>{translate(`resources.room.bokaMera`).toUpperCase()}</Typography>
                </Box>
                <GreenSwitch checked={switchValue.bokaMera} onChange={onChangSwitch('bokaMera')} size='small'></GreenSwitch>
              </Box>
              <Box>
                <Button color='primary' onClick={onClickMetaData} className={classes.btnMetaData} style={{ padding: '8px 16px', marginTop: '2em' }}  >
                  <Typography className={classes.textMetaData} >{translate(`resources.room.metedata`)}</Typography>
                </Button>
              </Box>


            </Box>
          </Box>

        </DialogContent>
        <DialogActions>
          <Box display='flex' width='100%' justifyContent='flex-end' my={3} mr={3}>
            <Box display='flex' alignItems='flex-end' mr={3}>
              <Typography className={classes.btnCancel}
                style={{ cursor: 'pointer', verticalAlign: 'bottom' }}
                onClick={handleClose}>
                {translate(`pos.dashboard.CANCEL`)}</Typography>
            </Box>
            <Button
              disabled={validate.roomLocation.isError ||
                validate.number.isError ||
                validate.controlCode.isError ||
                validate.roomName.isError ||
                validateMetaDatas.find(value => value.name.isError == true) != undefined ||
                validateMetaDatas.find(value => value.value.isError == true) != undefined ||
                loading}
              variant="contained" color='primary' size='large' onClick={handelAddRoom}>
              {loading && (
                <CircularProgress
                  size={25}
                  thickness={2}
                  color='inherit'
                />
              )}
              <Typography className={classes.btnCreate}>{translate(`resources.room.addRoom`)}</Typography>
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Box >

  );
}
export default CreateRoomDialog